import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { ANCHOR } from '../../../common/consts/common';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import forInvestorsMenuItem from 'common/messages/ForInvestorsMenu.intl';
import LanguageService from 'services/Language.service';
import styles from '../ForInvestors.module.scss';
import ContentStore from 'stores/Content.store';

@observer
@injectIntl
export default class SideMenu extends Component {
  render() {
    const language = LanguageService.getLang();
    const isIssueOfSharesActive =
      ContentStore.content.IsIssueOfSharesActiveInMenu && language === 'pl';
    const forInvestorsMenu = [
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.reports),
        hash: ANCHOR.REPORTS[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.currentReports
        ),
        hash: ANCHOR.CURRENT_REPORTS[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.presentations
        ),
        hash: ANCHOR.PRESENTATIONS[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.shareholders),
        hash: ANCHOR.SHAREHOLDERS[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.generalMeetings
        ),
        hash: ANCHOR.GENERAL_MEETINGS[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.strategy),
        hash: ANCHOR.STRATEGY[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.mission),
        hash: ANCHOR.MISSIONANDVISION[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.authorities),
        hash: ANCHOR.AUTHORITIES[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.mediaAboutUs),
        hash: ANCHOR.MEDIAABOUTUS[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.csr),
        hash: ANCHOR.CSR[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.corporateGovernance
        ),
        hash: ANCHOR.CORPORATEGOVERNANCE[language]
      },
      {
        title: this.props.intl.formatMessage(forInvestorsMenuItem.history),
        hash: ANCHOR.HISTORY[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.infoAboutCompany
        ),
        hash: ANCHOR.INFO_ABOUT_COMPANY[language]
      },
      {
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.plannedEvents
        ),
        hash: ANCHOR.PLANNED_EVENTS[language]
      }
    ];

    if (isIssueOfSharesActive) {
      forInvestorsMenu.push({
        title: this.props.intl.formatMessage(
          forInvestorsMenuItem.issueOfShares
        ),
        hash: ANCHOR.ISSUE_OF_SHARES[language]
      });
    }

    return (
      <div className={styles.SideMenu}>
        {forInvestorsMenu.map((el, ix) => {
          if (el.hash) {
            return (
              <Link to={el.hash} key={ix} className={styles.SideMenuBtn}>
                <div>{el.title}</div>
              </Link>
            );
          } else {
            return (
              <a href={el.href} key={ix} className={styles.SideMenuBtn}>
                <div>{el.title}</div>
              </a>
            );
          }
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/SideMenu.js